var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7905,
    cy: 16.7905,
    r: 16.7905,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 19.395C13.9899 19.395 13.8884 19.4098 13.8359 19.4245V20.3893C13.8982 20.4041 13.976 20.4082 14.0833 20.4082C14.4756 20.4082 14.7172 20.21 14.7172 19.875C14.7172 19.5752 14.5092 19.395 14.1406 19.395ZM16.9966 19.4048C16.8328 19.4048 16.7264 19.4196 16.6633 19.4343V21.572C16.7264 21.5868 16.8279 21.5868 16.9197 21.5868C17.5888 21.5917 18.0245 21.2231 18.0245 20.4434C18.0295 19.7636 17.6322 19.4048 16.9966 19.4048Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8389 9.00952H12.2865C11.8521 9.00952 11.4354 9.18211 11.1282 9.48931C10.821 9.79651 10.6484 10.2132 10.6484 10.6476V23.7524C10.6484 24.1868 10.821 24.6035 11.1282 24.9107C11.4354 25.2179 11.8521 25.3905 12.2865 25.3905H22.1151C22.5496 25.3905 22.9662 25.2179 23.2734 24.9107C23.5806 24.6035 23.7532 24.1868 23.7532 23.7524V13.9238L18.8389 9.00952ZM15.1516 20.6318C14.8985 20.8693 14.525 20.9758 14.0901 20.9758C14.0057 20.9767 13.9215 20.9718 13.8378 20.9611V22.129H13.1056V18.9053C13.436 18.856 13.7699 18.8335 14.104 18.8381C14.5602 18.8381 14.8846 18.9249 15.1032 19.0994C15.3113 19.2648 15.4522 19.5359 15.4522 19.8553C15.4513 20.1764 15.3449 20.4475 15.1516 20.6318ZM18.2697 21.7416C17.9257 22.0275 17.4023 22.1634 16.7626 22.1634C16.3793 22.1634 16.1082 22.1389 15.9239 22.1143V18.9061C16.2545 18.8578 16.5883 18.8351 16.9223 18.8381C17.5424 18.8381 17.9453 18.9495 18.2598 19.187C18.5998 19.4393 18.8127 19.8414 18.8127 20.4189C18.8127 21.0438 18.5842 21.4754 18.2697 21.7416ZM21.2961 19.4688H20.0413V20.2149H21.2142V20.8161H20.0413V22.1298H19.2992V18.8627H21.2961V19.4688ZM18.8389 14.7429H18.0199V10.6476L22.1151 14.7429H18.8389Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePdf);
export default __webpack_public_path__ + "static/media/IconePdf.abe5ca62d056f1590d85e5b981a5089b.svg";
export { ForwardRef as ReactComponent };